<template>
  <el-menu v-bind="$attrs" v-on="$listeners" class="front-base-side-menu">
    <slot></slot>
  </el-menu>
</template>

<script>
import ElMenu from "element-ui/packages/menu/src/menu"

export default {
  name: "BaseSideMenu",
  components: {
    ElMenu
  }
}
</script>

<style lang="scss">
.front-base-side-menu.el-menu {
  background: transparent;
  border: none;
  .el-menu-item {
    background: rgba(255, 255, 255, 1);
    display: block;
    width: 100%;
    height: 48px;
    opacity: unset !important;
    cursor: default !important;
    font-size: 14px;
    font-weight: 400;
    color: rgba(96, 98, 102, 1);
    line-height: 46px;
    padding: 0 0 0 28px !important;
    &:last-child::after {
      display: none;
    }
    &::after {
      content: "";
      display: block;
      height: 2px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #f5f5f5;
    }
    &.is-active {
      padding: 0 0 0 24px !important;
      border-left: 4px solid #0486fe;
      color: #0486fe;
      font-weight: 600;
    }
  }
  .el-menu-item-group__title {
    margin: 0;
    padding: 0 !important;
    opacity: unset;
    cursor: default;
    line-height: 38px;
    height: 38px;
    font-size: 14px;
    font-weight: 400;
    color: #c0c4cc;
    span {
      vertical-align: middle;
    }
  }
  .el-menu--inline {
    display: block !important;
  }
}
</style>
